export const TYPE_TRANSCRIPT = 'transcript';
export const TYPE_BOOKMARK = 'bookmark';
